export default "__VITE_ASSET__BrzWYRHh__"